// extracted by extract-css-chunks-webpack-plugin
module.exports = {"info_box":"info_box-3DzqThS0 clearfix","comment":"comment-16Hpu3rO","pic":"pic-2X18zdhe","v_logo":"v_logo-2YYBHx2Z","text":"text-1FgxwkIz","time":"time-yN5atMQQ"};